import { createApp } from 'vue'
import App from './App.vue'
import { APP_CONFIG } from '@/config'
import {
    Button, 
    Icon, 
    NavBar, 
    Form, 
    Field, 
    Toast, 
    Dialog, 
    Empty,
    Tabbar,
    TabbarItem,
    Tab,
    Tabs,
    Popup,
    Loading,
    Cell,
    CellGroup
} from 'vant';

import 'vant/lib/index.css';
import router from './router'
import './css/index.css';

const app = createApp(App)

// 注册所有Vant组件
app.use(Button)
app.use(Empty)
app.use(Icon)
app.use(Toast)
app.use(Form)
app.use(Dialog)
app.use(Field)
app.use(NavBar)
app.use(Tabbar)
app.use(TabbarItem)
app.use(Tab)
app.use(Tabs)
app.use(Popup)
app.use(Loading)
app.use(Cell)
app.use(CellGroup)
app.use(router)

// 添加全局用户状态监听器
app.config.globalProperties.$userState = {
  currentUserId: null,
  isLoggedIn: false,
  
  // 监听用户状态变化
  watchUserChange() {
    const checkUserChange = () => {
      const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}')
      const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'
      const currentUserId = currentUser.id
      
      // 如果用户ID发生变化，触发全局事件
      if (this.currentUserId !== currentUserId || this.isLoggedIn !== isLoggedIn) {
        console.log('用户状态发生变化:', {
          oldUserId: this.currentUserId,
          newUserId: currentUserId,
          oldIsLoggedIn: this.isLoggedIn,
          newIsLoggedIn: isLoggedIn
        })
        
        this.currentUserId = currentUserId
        this.isLoggedIn = isLoggedIn
        
        // 触发全局事件，通知所有组件用户已切换
        window.dispatchEvent(new CustomEvent('userChanged', {
          detail: {
            userId: currentUserId,
            isLoggedIn: isLoggedIn,
            user: currentUser
          }
        }))
      }
    }
    
    // 初始检查
    checkUserChange()
    
    // 定期检查用户状态变化
    setInterval(checkUserChange, 1000)
  }
}

// 启动用户状态监听
app.config.globalProperties.$userState.watchUserChange()

// 设置网站标题
document.title = APP_CONFIG.COMPANY_NAME || '电子服务平台'

app.mount('#app')
